const TOKEN_KEY = 'customs_auth_token'
const PERMS_KEY = 'customs_permissions'
const USER_KEY = 'customs_user'
/** 是否为「长效」会话：勾选 7 天免登录时使用 localStorage，否则 sessionStorage（关浏览器后即需重登）。 */
const PERSIST_FLAG_KEY = 'customs_auth_persist'

const AUTH_CHANGED_EVENT = 'customs-auth-changed'

function emitAuthChanged() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(AUTH_CHANGED_EVENT))
  }
}

/** @param {Storage} st */
function clearAuthSlots(st) {
  if (!st) return
  st.removeItem(TOKEN_KEY)
  st.removeItem(PERMS_KEY)
  st.removeItem(USER_KEY)
}

/** @returns {'local'|'session'} */
function resolveActiveStorageKind() {
  try {
    if (localStorage.getItem(PERSIST_FLAG_KEY) === '1') {
      return 'local'
    }
    return 'session'
  } catch (e) {
    return 'session'
  }
}

export function getToken() {
  try {
    const kind = resolveActiveStorageKind()
    if (kind === 'local') {
      return localStorage.getItem(TOKEN_KEY) || ''
    }
    return sessionStorage.getItem(TOKEN_KEY) || ''
  } catch (e) {
    return ''
  }
}

/**
 * @param {{ token?: string, user?: object, persistent?: boolean }} opt
 */
export function setAuth({ token, user, persistent }) {
  /** @type {boolean} */
  let usePersist
  if (persistent === true) {
    usePersist = true
  } else if (persistent === false) {
    usePersist = false
  } else {
    usePersist = resolveActiveStorageKind() === 'local'
  }

  const primary = usePersist ? localStorage : sessionStorage
  const secondary = usePersist ? sessionStorage : localStorage

  try {
    clearAuthSlots(secondary)
    if (usePersist) {
      localStorage.setItem(PERSIST_FLAG_KEY, '1')
    } else {
      localStorage.removeItem(PERSIST_FLAG_KEY)
      clearAuthSlots(localStorage)
    }

    const perms = (user && user.permissions) || []
    if (token) {
      primary.setItem(TOKEN_KEY, token)
    }
    primary.setItem(PERMS_KEY, JSON.stringify(perms))
    primary.setItem(USER_KEY, JSON.stringify(user || {}))
  } catch (e) {
    // 私密模式或存储满时尽量不抛错打断流程；后续请求仍会 401 引导登录
  }
  emitAuthChanged()
}

export function clearAuth() {
  try {
    clearAuthSlots(sessionStorage)
    clearAuthSlots(localStorage)
    localStorage.removeItem(PERSIST_FLAG_KEY)
  } catch (e) {}
  emitAuthChanged()
}

export function getPermissions() {
  try {
    const st = resolveActiveStorageKind() === 'local' ? localStorage : sessionStorage
    const s = st.getItem(PERMS_KEY)
    return s ? JSON.parse(s) : []
  } catch (e) {
    return []
  }
}

export function hasPerm(code) {
  const p = getPermissions()
  if (p.includes('*')) {
    return true
  }
  return p.includes(code)
}

/** 上传管理侧栏/批量上传页：仅上传相关码（报关单文件查询属报关管理，见 menu.declarations.batch_file_query） */
export const DECLARATION_UPLOAD_PERMS = [
  'menu.declaration_uploads',
  'menu.declaration_uploads.batch',
  'menu.declaration_uploads.links',
  'declaration_uploads.read',
  'declaration_uploads.write',
]

export function hasAnyPerm(codes) {
  if (!Array.isArray(codes)) {
    return false
  }
  return codes.some((c) => hasPerm(c))
}

export function canAccessDeclarationUploads() {
  return hasAnyPerm(DECLARATION_UPLOAD_PERMS)
}

/**
 * 与后端 RbacGate 上传写操作菜单兼容一致：显式 declaration_uploads.write，
 * 或对应子菜单码（仅挂菜单、未挂「上传与维护关联」时也能点上传/删关联/重发微秘书等）。
 *
 * @param {'batch'|'links'|'fileQuery'} kind 批量上传 | 关联数据 | 报关单文件查询
 */
export function canDeclarationUploadsWrite(kind) {
  if (hasPerm('*') || hasPerm('declaration_uploads.write')) {
    return true
  }
  if (hasPerm('menu.declaration_uploads')) {
    return true
  }
  if (kind === 'batch' && hasPerm('menu.declaration_uploads.batch')) {
    return true
  }
  if (kind === 'links' && hasPerm('menu.declaration_uploads.links')) {
    return true
  }
  if (kind === 'fileQuery' && hasPerm('menu.declarations.batch_file_query')) {
    return true
  }
  return false
}

export function getStoredUser() {
  try {
    const st = resolveActiveStorageKind() === 'local' ? localStorage : sessionStorage
    const s = st.getItem(USER_KEY)
    return s ? JSON.parse(s) : null
  } catch (e) {
    return null
  }
}

export function onAuthChanged(listener) {
  if (typeof window === 'undefined' || typeof listener !== 'function') return () => {}
  window.addEventListener(AUTH_CHANGED_EVENT, listener)
  return () => window.removeEventListener(AUTH_CHANGED_EVENT, listener)
}
